import { useContext } from "react";

import type { Config } from "@/helpers/config";

import { ConfigContext } from "./ConfigContext";

export function useConfig<TKey extends keyof Config>(key: TKey): Config[TKey] {
  const value = useContext(ConfigContext);

  if (value == null) {
    throw new Error("ConfigProvider not initialized");
  }

  return value.snapshot.getValue(key, undefined, value.user);
}
